module.exports = __webpack_public_path__ + "771099482bdc1571ece41073b1752596.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-icons_454545_256x240.png
// module id = 248
// module chunks = 0